<div class="gains-collapse-container">
  <nz-collapse [nzAccordion]="false" [nzExpandIconPosition]="'end'">
    <nz-collapse-panel
      *ngFor="let panel of panels"
      [nzHeader]="headerTemplate"
      [(nzActive)]="panel.active"
      [attr.data-panel-title]="panel.title"
      [nzShowArrow]="true"
      [nzExpandedIcon]="expandIcon"
      [ngClass]="{
        'panel--optional': isOptionalStatus(panel.status) && !isPanelVisuallyEnabled(panel),
        'panel--optional-enabled': isOptionalStatus(panel.status) && isPanelVisuallyEnabled(panel)
      }"
    >
      <ng-template #expandIcon>
        <span class="gains-collapse-expand-icon ant-collapse-arrow">
          <svg-icon src="assets/icons/arrow-down.svg" class="gains-collapse-expand-icon--collapsed"></svg-icon>
          <svg-icon src="assets/icons/arrow-up.svg" class="gains-collapse-expand-icon--expanded"></svg-icon>
        </span>
      </ng-template>

      <ng-template #headerTemplate>
        <div class="collapse-header-content">
          <div class="collapse-header-left">
            <span class="panel-icon panel-icon-emoji">{{ panel.icon }}</span>

            <div class="collapse-header-text">
              <div class="panel-title">
                {{ panel.title }}
                <span *ngIf="shouldShowPanelDot(panel)" class="optional-active-dot" aria-hidden="true"></span>
              </div>
              <div class="panel-description">{{ panel.description }}</div>
            </div>
          </div>
          <div class="collapse-header-right">
            <span *ngIf="showColumns" class="columns-count">{{ getEnabledRowCount(panel) }}/{{ getTotalRowCount(panel) }}</span>

            <ng-container *ngIf="showStatus && panel.status">
              <div
                *ngIf="isOptionalStatus(panel.status); else requiredStatus"
                class="optional-status-toggle"
                tabindex="0"
                (click)="$event.stopPropagation()"
                (keydown)="$event.stopPropagation()"
              >
                <nz-switch
                  [ngModel]="getPanelStatusValue(panel)"
                  (ngModelChange)="onPanelStatusToggle(panel, $event)"
                  (click)="$event.stopPropagation()"
                  (keydown)="$event.stopPropagation()"
                ></nz-switch>
                <span class="schedule-status-pill schedule-status-pill--optional">{{ panel.status }}</span>
              </div>

              <ng-template #requiredStatus>
                <span class="schedule-status-pill">{{ panel.status }}</span>
              </ng-template>
            </ng-container>
          </div>
        </div>
      </ng-template>

      <!-- Collapse panel content -->
      <div class="collapse-content">
        <gains-grid [rowData]="getEnrichedRowData(panel)" [colDefs]="columnDefs" [rowCount]="false" [showCount]="false" [gridOptions]="getGridOptionsForPanel(panel)"></gains-grid>
      </div>
    </nz-collapse-panel>
  </nz-collapse>
</div>
